import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ComponentToShow = 'ChatScheduledMessages' | 'btAiAssistant' | 'Notes' | 'Tasks' | 'Reminders' | 'QuickAgents';
export type QuickAgentsScope = 'current' | 'all';

export const ALL_SIDEBAR_COMPONENTS: readonly ComponentToShow[] = [
  'ChatScheduledMessages',
  'btAiAssistant',
  'Notes',
  'Tasks',
  'Reminders',
  'QuickAgents',
] as const;

export const INLINE_SIDEBAR_COMPONENTS: readonly ComponentToShow[] = [
  'Notes',
  'Tasks',
  'ChatScheduledMessages',
  'Reminders',
  'QuickAgents',
] as const;

interface BtLayoutSidebarState {
  isOpen: boolean;
  componentToShow: ComponentToShow;
  quickAgentsInitialScope?: QuickAgentsScope;
}

const initialState: BtLayoutSidebarState = {
  isOpen: false,
  componentToShow: 'ChatScheduledMessages',
  quickAgentsInitialScope: undefined,
};

const btLayoutSidebarSlice = createSlice({
  name: "btLayoutSidebar",
  initialState,
  reducers: {
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
      if (!action.payload) {
        state.quickAgentsInitialScope = undefined;
      }
    },
    toggleSidebar: (state) => {
      if (state.isOpen) {
        state.quickAgentsInitialScope = undefined;
      }
      state.isOpen = !state.isOpen;
    },
    setComponentToShow: (state, action: PayloadAction<ComponentToShow>) => {
      state.componentToShow = action.payload;
      state.quickAgentsInitialScope = undefined;
    },
    openWithComponent: (state, action: PayloadAction<ComponentToShow>) => {
      state.isOpen = true;
      state.componentToShow = action.payload;
      state.quickAgentsInitialScope = undefined;
    },
    openQuickAgentsWithScope: (state, action: PayloadAction<QuickAgentsScope>) => {
      state.isOpen = true;
      state.componentToShow = 'QuickAgents';
      state.quickAgentsInitialScope = action.payload;
    },
    closeSidebar: (state) => {
      state.isOpen = false;
      state.quickAgentsInitialScope = undefined;
    },
    clearQuickAgentsInitialScope: (state) => {
      state.quickAgentsInitialScope = undefined;
    },
  },
});

export const btLayoutSidebarActions = btLayoutSidebarSlice.actions;

export const {
  setIsOpen,
  toggleSidebar,
  setComponentToShow,
  openWithComponent,
  openQuickAgentsWithScope,
  closeSidebar,
  clearQuickAgentsInitialScope,
} = btLayoutSidebarSlice.actions;

export default btLayoutSidebarSlice.reducer;
